<template>
  <div>
    <v-btn style="background-color: #FFB800; color: white; border-radius: 10px;" size="sm">
      <b-icon icon="download" scale="2" variant="default"></b-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'buttonPrint'
 }
</script>